import { InspectionPOItem } from 'app/modules/inspection/types';
import { QMASLazyDocument } from 'app/modules/ui';
import { ShippingInformation } from './shipping-information';
import find from 'lodash/find';

export const DESCRIPTION_DEF = [
  {
    label: 'On-site Checking Progress',
    dataIndex: 'progress',
    span: 3,
    render: (value: string) => {
      return value || 'N/A';
    }
  },
  {
    label: null,
    dataIndex: 'sellingUnitContent',
    span: 3,
    render: (
      value,
      _,
      meta: {
        poItem: InspectionPOItem;
      }
    ) => {
      const { poItem } = meta;

      return (
        <ShippingInformation
          value={value}
          type={'sellingUnitContent'}
          shippingInformation={find(
            poItem?.productProfile.shippingInformation,
            { type: 'selling_unit' }
          )}
        />
      );
    }
  },
  {
    label: null,
    dataIndex: 'innerPackContent',
    span: 3,
    render: (
      value,
      _,
      meta: {
        poItem: InspectionPOItem;
      }
    ) => {
      const { poItem } = meta;
      return (
        <ShippingInformation
          value={value}
          type={'innerPackContent'}
          shippingInformation={find(
            poItem?.productProfile.shippingInformation,
            { type: 'inner_carton' }
          )}
        />
      );
    }
  },
  {
    label: null,
    dataIndex: 'outerCartonContent',
    span: 3,
    render: (
      value,
      _,
      meta: {
        poItem: InspectionPOItem;
      }
    ) => {
      const { poItem } = meta;
      return (
        <ShippingInformation
          value={value}
          type={'outerCartonContent'}
          shippingInformation={find(
            poItem?.productProfile.shippingInformation,
            { type: 'outer_carton' }
          )}
        />
      );
    }
  },
  {
    label: 'Remarks',
    dataIndex: 'remark',
    span: 3,
    render: (value: string) => {
      return value || 'N/A';
    }
  },
  {
    label: 'Reference Media',
    dataIndex: 'referenceMedia',
    className: 'reference-media',
    render: (value: any) => {
      if (Array.isArray(value)) {
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            {value.map((item) => {
              return (
                <QMASLazyDocument
                  key={item}
                  alt="attachments"
                  documentId={item}
                />
              );
            })}
          </div>
        );
      }
      return null;
    }
  }
];
